module.exports = __webpack_public_path__ + "static/media/KR.793c8ae2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KR.svg
// module id = 2189
// module chunks = 7